module.exports = require("@amzn/awsui-components-react-v3/polaris/container/internal");